var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_chevron_right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.5469 36L22.5 14.9991L28.2265 9L54 36L28.2265 63L22.5 57.0009L42.5469 36Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronRight);
export default __webpack_public_path__ + "static/media/ic_chevron_right.c425188ee0500fec152aac85fdba3b01.svg";
export { ForwardRef as ReactComponent };